import React from "react";
import DaysContainer from "../../containers/schedule/DaysContainer";
import SideSheet from "./SideSheet";

const Schedule = (props) => (
  <div>
    <SideSheet {...props}>
      <DaysContainer {...props} brackets={props.bracketOptions} />
    </SideSheet>
  </div>
);

export default Schedule;
